import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { EditableModuleAndSection, Policy } from '../types';
import { PoliciesSelectorController } from '../controller/PoliciesSelectorController';

export class PoliciesSelectorWebComponent extends BaseWebComponentElement {
  private onPolicyClickedFn?: (clickedPolicy: Policy) => Promise<void>;
  private onPolicyChangedWithSuccessFn?: () => Promise<void>;
  private onPolicyChangedWithErrorFn?: (error: Error) => Promise<void>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PoliciesSelectorController,
    });
  }

  set onPolicyClicked(onPolicyClickedFn: ((clickedPolicy: Policy) => Promise<void>) | undefined) {
    this.onPolicyClickedFn = onPolicyClickedFn;
  }

  get onPolicyClicked(): ((clickedPolicy: Policy) => Promise<void>) | undefined {
    return this.onPolicyClickedFn;
  }

  set onPolicyChangedWithSuccess(onPolicyChangedWithSuccessFn: (() => Promise<void>) | undefined) {
    this.onPolicyChangedWithSuccessFn = onPolicyChangedWithSuccessFn;
  }

  get onPolicyChangedWithSuccess(): (() => Promise<void>) | undefined {
    return this.onPolicyChangedWithSuccessFn;
  }

  set onPolicyChangedWithError(onPolicyChangedWithErrorFn: ((error: Error) => Promise<void>) | undefined) {
    this.onPolicyChangedWithErrorFn = onPolicyChangedWithErrorFn;
  }

  get onPolicyChangedWithError(): ((error: Error) => Promise<void>) | undefined {
    return this.onPolicyChangedWithErrorFn;
  }

  get selectedTarget(): Policy {
    const value = this.getAttribute('data-selected-target');
    return value ? JSON.parse(value) : {};
  }

  set selectedTarget(value) {
    if (!value) {
      return;
    }
    this.setAttribute('data-selected-target', JSON.stringify(value));
  }

  get policy(): Array<Policy> {
    return this.getValueFromAttribute(this, 'data-policies', []);
  }

  set policy(value) {
    if (!value) {
      return;
    }
    this.setAttribute('data-policies', JSON.stringify(value));
  }

  set disabled(value: boolean) {
    this.setAttribute('data-is-disabled', JSON.stringify(value ? true : false));
  }

  get disabled(): boolean {
    const value = this.getAttribute('data-is-disabled');
    return value ? JSON.parse(value) : false;
  }

  set policySelectorParams(value: Policy) {
    if (!value) {
      return;
    }

    this.setAttribute('data-policy-selector-params', JSON.stringify(value));
  }

  get policySelectorParams(): Policy {
    const value = this.getAttribute('data-policy-selector-params');
    return value ? JSON.parse(value) : {};
  }

  get editableModuleAndSection(): EditableModuleAndSection {
    return this.getValueFromAttribute(this, 'data-editable-module-and-section', {});
  }

  set editableModuleAndSection(value) {
    if (!value) {
      return;
    }
    this.setAttribute('data-editable-module-and-section', JSON.stringify(value));
  }

  // exclude policies with inherited section
  get excludePolicies(): boolean {
    return this.getValueFromAttribute(this, 'data-exclude-policies', false);
  }

  set excludePolicies(value) {
    if (!value) {
      return;
    }
    this.setAttribute('data-exclude-policies', JSON.stringify(value ? true : false));
  }


}
